export const mobileSwitcher = {
  layoutChanged: false,
  init() {
    this.menuElem = document.querySelector('.menu')
    this.listElem = document.querySelector(
      '.content-container-with-menu > .resolution-list-container'
    )
    this.reportElem = document.querySelector(
      '.content-container-with-menu > .resolution-report-container'
    )
    this.topBarElem = document.querySelector('.resolution-topBar')

    this.resizeHandlerBinded = this.resizeHandler.bind(this)
  },
  resizeHandler() {
    if (window.innerWidth > 750) {
      this.showList()
    }
  },
  showReport() {
    if (window.innerWidth <= 750) {
      this.init()

      this.menuElem.style.display = 'none'
      this.topBarElem.style.display = 'none'
      this.listElem.style.display = 'none'
      this.reportElem.style.display = 'block'
      this.reportElem.style.left = '0'

      this.layoutChanged = true

      // TODO: save scroll position of list

      window.addEventListener('resize', this.resizeHandlerBinded, true)
    }
  },
  showList() {
    if (this.layoutChanged) {
      this.menuElem.style.display = 'block'
      this.topBarElem.style.display = ''
      this.listElem.style.display = ''
      this.reportElem.style.display = ''
      this.reportElem.style.left = ''

      this.layoutChanged = false

      window.removeEventListener('resize', this.resizeHandlerBinded, true)
    }
  },
  toggleHistoryLayoutChange() {
    // related for tablet and less
    this.menuElem = document.querySelector('.menu')
    if (this.menuElem?.classList?.contains('mbz')) {
      this.menuElem.classList.remove('mbz')
    } else {
      // eslint-disable-next-line no-unused-expressions
      this.menuElem?.classList?.add('mbz')
    }
  },
}
